<!-- =========================================================================================
  File Name: ClientEdit.vue
  Description: Client Edit page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<style lang="scss">
.con-img-upload {
  background: #efeeee;
}
.custom-domain-wrap {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.input-wdt {
  width: 70%;
  margin-right: 15px;
}
.button-wrap {
  text-align: right;
}
.header-custome{padding-left: 3px; margin-bottom: 15px;}
.vs-tabs--ul{box-shadow: none;}
#page-client-add .tab-action-btn-fill-conatiner.con-vs-tabs .vs-tabs--content {
    padding: 0px 10px 23px!important;
}
#page-client-add .vx-card {min-height: calc(100vh - 212px);}
</style>
<template>
  <div id="page-client-add">
    <div class="header-custome">
      <h2>Edit Clients</h2>
    </div>
    <vx-card v-if="client_data">
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <vs-tabs position="left" v-model="activeTab" class="tab-action-btn-fill-conatiner">
          <vs-tab label="Client Info" icon-pack="feather" icon="icon-info">
            <div class="tab-text">
              <client-edit-tab-info class="mt-0" :data="client_data" />
            </div>
          </vs-tab>
          <vs-tab label="Settings" icon-pack="feather" icon="icon-settings">
            <div class="tab-text">
              <client-edit-tab-settings class="mt-0" :data="client_data" />
            </div>
          </vs-tab>
          <vs-tab label="Branding" icon-pack="feather" icon="icon-settings">
            <div class="tab-text">
              <client-edit-tab-branding class="mt-0" :data="client_data" />
            </div>
          </vs-tab>
          <vs-tab label="Features" icon-pack="feather" icon="icon-settings">
            <div class="tab-text">
              <client-edit-tab-feature class="mt-0" :data="Features" />
            </div>
          </vs-tab>
          <vs-tab label="Plan Details" icon-pack="feather" icon="icon-settings">
            <div class="tab-text">
              <client-edit-tab-plan-details class="mt-0" :data="PlanDetails" />
            </div>
          </vs-tab>
          <vs-tab label="Post Login Options" icon-pack="feather" icon="icon-settings">
            <div class="tab-text">
              <client-post-login-option class="mt-0" />
            </div>
          </vs-tab>
          <vs-tab label="Default Options" icon-pack="feather" icon="icon-settings">
            <div class="tab-text">
              <client-edit-tab-default-options class="mt-0" />
            </div>
          </vs-tab>
        </vs-tabs>
      </div>
    </vx-card>
  </div>
</template>

<script>
import ClientEditTabInfo from "./ClientEditTabInfo.vue";
import ClientEditTabSettings from "./ClientEditTabSettings.vue";
import ClientEditTabBranding from "./ClientEditTabBranding.vue";
import ClientEditTabFeature from "./ClientEditTabFeature.vue";
import ClientEditTabPlanDetails from "./ClientEditTabPlanDetails.vue";
import ClientPostLoginOption from "./ClientPostLoginOption.vue";
import ClientEditTabDefaultOptions from "./ClientEditTabDefaultOptions";

// Store Module
import moduleClientManagement from "@/store/client-management/moduleClientManagement.js";
var vm;
export default {
  components: {
    ClientEditTabInfo,
    ClientEditTabSettings,
    ClientEditTabBranding,
    ClientEditTabFeature,
    ClientEditTabPlanDetails,
    ClientPostLoginOption,
    ClientEditTabDefaultOptions
  },
  data() {
    return {
      ClientId: 0,
      client_data: null,
      client_not_found: false,
      Features: [],
      PlanDetails: {
        MaxAttendeesPerClient: 10,
        EnhancedEventBranding: false,
        AllowSessionOnDemandVideo: false,
        AllowSessionLiveSimulated: false,
        AllowSessionRoundtable: false,
        ShowBrandingEventSetup: false,
        MaxEventDays: 2,
        EventAccessPostEvent: false,
        EnhancedRegistration: false,
        ContractStartDate: new Date(),
        ContractEndDate: new Date(),
        PricePerExtraAttendee: 100
      },
      PostLoginOptions: {
        DefaultLoginLandingPage: '/eventBased',
        ClientLobbyHTML: ""
      },
      /*
        This property is created for fetching latest data from API when tab is changed

        Please check it's watcher
      */
      activeTab: 0
    };
  },
  watch: {
    activeTab() {
      this.fetch_client_data(this.$route.params.clientId);
    }
  },
  methods: {    
    fetch_client_data(ClientId) {
      if (ClientId === undefined) {
        ClientId = null;
      }
      this.ClientId = ClientId;
      this.$store
        .dispatch("clientManagement/fetchClient", ClientId)
        .then(res => {
          this.client_data = res.data;
        })
        .catch(err => {
         /* if (err.response.status === 404) {
            this.client_not_found = true;
            return;
          }*/
          console.error(err);
        });

      this.$store
        .dispatch("clientManagement/fetchClientFeatures", ClientId)
        .then(res => {
          this.Features = (res.AllFeatures ? res.AllFeatures : []);  
      })

      this.$store
        .dispatch("clientManagement/fetchClientPlanDetails", ClientId)
        .then(res => {   
          if(res.PlanDetails)
          {            
            this.PlanDetails = res.PlanDetails;
          }
              
      })

        this.$store
        .dispatch("clientManagement/fetchPostLoginOptions", ClientId)
        .then(res => {   
          if(res.PostLoginOptions)
          {            
            this.PostLoginOptions = res.PostLoginOptions;
          }          
              
      })

       /* this.$store
        .dispatch("clientManagement/fetchBrandingJson", {clientId:ClientId})
        .then(res => {
          if(res)
          {
          this.BrandingJson = res;
          }        
        }).catch(err => { 
        console.log(err)         
        });*/
    }
  },
  created() {
    vm = this;
    //debugger;
    // Register Module clientManagement Module
    if (!moduleClientManagement.isRegistered) {
      this.$store.registerModule("clientManagement", moduleClientManagement);
      moduleClientManagement.isRegistered = true;
    }
    this.fetch_client_data(this.$route.params.clientId);
  }
};
</script>

